import { Component } from '@angular/core';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-custom-public-first',
  templateUrl: './custom-public-first.component.html',
  styleUrl: './custom-public-first.component.scss'
})
export class CustomPublicFirstComponent {
  constructor(public bannerComponent: CmsComponentData<CmsBannerComponent>, protected config: OccConfig) { }
  publicnode: Observable<any> = this.bannerComponent.data$;
  openModal() {
    document.body.style.overflowY = 'auto';
    document.getElementById('commonleaving_abandonedPop')!.style.display = 'block';
  }
  closeModal() {
    document.body.style.overflowY = 'auto';
    document.getElementById('commonleaving_abandonedPop')!.style.display = 'none';
  }
  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.desktop.url;
  }
}
